/**
 * Determines the minimum and maximum values from an array of numbers.
 *
 * @param arr - The array of numbers.
 *
 * @returns A tuple where the first element is the minimum value and the second element is the maximum value from the array.
 */
export const minMaxFromArray = (arr: number[]): [number, number] => {
  return [Math.min(...arr), Math.max(...arr)];
};
